import PageHeading from '~/components/PageHeading';
import FeatureIntro from '~/components/FeatureIntro';
import React, { useState } from 'react';
import { useFlowQuery, useGiftCertificatesQuery } from '~/lib/Queries';
import Loading from '~/components/Loading';
import Table from '~/components/Table';
import { formatCurrency } from '~/lib/CurrencyHelpers';
import { formatDateShort, formatDateTime } from '~/lib/DateTime';
import GiftCertificatePanel from '~/components/giftcertificates/GiftCertificatePanel';
import AdminAddGiftCertificatePanel from '~/components/giftcertificates/AdminAddGiftCertificatePanel';
import {
    ArchiveBoxArrowDownIcon,
    CalendarDaysIcon,
    Cog6ToothIcon,
    UserGroupIcon,
} from '@heroicons/react/24/outline';
import DotDotDotMenu from '~/components/DotDotDotMenu';
import ImportGiftCertificatesModal from '~/components/giftcertificates/ImportGiftCertificatesModal';
import SectionPicker from '~/components/SectionPicker';
import FlowBuilder from '~/components/flows/FlowBuilder';
import { getBusinessId } from '~/lib/Api';

const GiftCertificateFlows = ({}) => {
    const flowableType = 'giftcertificatebusiness';
    const flowableId = getBusinessId();
    const { data, isLoading } = useFlowQuery(flowableType, flowableId);
    const hasSteps = data?.steps?.length > 0;

    return (
        <div>
            {!isLoading && !hasSteps && (
                <div className="text-gray-500 max-w-lg">
                    The default gift certificate email will be sent to the recipient when the gift certificate is delivered.
                    Click "Add Action" below to customize the email content.
                </div>
            )}
            <FlowBuilder
                flowableId={flowableId}
                flowableType={flowableType}
            />
        </div>
    );
}


const GiftCertificatesList = ({ giftCertificates, refetch }) => {
    const [selectedGiftCertificate, setSelectedGiftCertificate] =
        useState(null);

    if (!giftCertificates?.length) {
        return null;
    }

    return (
        <div>
            <Table
                headers={[
                    'Code',
                    'Purchased By',
                    'Recipient',
                    'Amount',
                    'Remaining',
                    'Expiration',
                ]}
                rowClassName="cursor-pointer"
                rows={giftCertificates.map(gc => [
                    gc.code?.code,
                    gc.purchaser_client?.email,
                    gc.recipient?.email,
                    formatCurrency(gc.value),
                    formatCurrency(gc.remaining_value),
                    gc.expires_at ? formatDateShort(gc.expires_at) : '∞',
                ])}
                onClick={row => {
                    console.log(
                        'row',
                        row,
                        giftCertificates.find(gc => gc.code?.code === row[0]),
                    );
                    setSelectedGiftCertificate(
                        giftCertificates.find(
                            gc => row[0] && gc.code?.code === row[0],
                        ),
                    );
                }}
            />
            <GiftCertificatePanel
                isOpen={!!selectedGiftCertificate}
                onClose={() => setSelectedGiftCertificate(null)}
                id={selectedGiftCertificate?.id}
                refetch={refetch}
            />
        </div>
    );
};

const GiftCertificatesIndexPage = ({}) => {
    const { data, isLoading, refetch } = useGiftCertificatesQuery();
    const [isShowingImport, setIsShowingImport] = useState(false);
    const [isAddingGiftCertificate, setIsAddingGiftCertificate] =
        useState(false);
    const [section, setSection] = useState('list');

    const giftCertificates = data?.giftCertificates || [];

    return (
        <div>
            <PageHeading
                heading="Gift Certificates"
                headerSibling={
                    <DotDotDotMenu
                        btnClassName="btn-gray-circle"
                        options={[
                            {
                                name: 'Import',
                                icon: <ArchiveBoxArrowDownIcon />,
                                onClick: () => setIsShowingImport(true),
                            },
                        ]}
                    />
                }
                rightContent={
                    section === 'list' && (
                        <div className="flex gap-2">
                            <button
                                type="button"
                                className="btn-pill"
                                onClick={() => setIsAddingGiftCertificate(true)}
                            >
                                Add Gift Certificate
                            </button>
                        </div>
                    )
                }
            />
            <FeatureIntro>
                        Increase sales by selling digital gift certificates.
                    </FeatureIntro>
            <SectionPicker
                options={[
                    { value: 'list', label: 'Gift Certificates' },
                    { value: 'flows', label: 'Automations' },
                ]}
                value={section}
                onChange={setSection}
                className="mb-6"
            />

            {section === 'list' && (
                <>
                    {isLoading && <Loading />}
                    {!isLoading && !giftCertificates?.length && (
                        <div className="panel px-6 py-4 text-gray-500">
                            There are no gift certificates
                        </div>
                    )}
                    {!isLoading && (
                        <GiftCertificatesList
                            giftCertificates={giftCertificates}
                            refetch={refetch}
                        />
                    )}
                </>
            )}

            {section === 'flows' && (
                <GiftCertificateFlows />
            )}

            <AdminAddGiftCertificatePanel
                isOpen={isAddingGiftCertificate}
                onClose={() => setIsAddingGiftCertificate(false)}
                onSave={refetch}
            />
            <ImportGiftCertificatesModal
                isOpen={isShowingImport}
                onClose={() => setIsShowingImport(false)}
                onSuccess={refetch}
            />
        </div>
    );
};

export default GiftCertificatesIndexPage;
